import {ClickerGCSEngine} from '../ClickerGame.types';
import {DI_TOKENS} from 'src/di/di.tokens';

import {injected} from 'brandi';
import {WindowVisibilityService} from 'src/services/WindowVisibilityService/WindowVisibilityService';

import {IGameScript} from '@specials/gcs-engine';

export class VisibilityChangeScript implements IGameScript {
  constructor(
    private readonly engine: ClickerGCSEngine,
    private readonly windowVisibilityService: WindowVisibilityService,
  ) {}

  public start(): void {
    this.windowVisibilityService.onVisibilityChange(this.handleVisibilityChange);
  }

  private handleVisibilityChange = (isVisible: boolean): void => {
    if (isVisible) {
      this.engine.resume();
    } else {
      this.engine.pause();
    }
  };

  public destroy(): void {
    this.windowVisibilityService.offVisibilityChange(this.handleVisibilityChange);
  }
}

injected(VisibilityChangeScript, DI_TOKENS.gcsEngine, DI_TOKENS.windowVisibilityService);
